import { FC } from 'react';
// component
import EditFormulaComponent from 'components/main/Formulas/Dosage/Edit';

const EditFormula: FC = () => <EditFormulaComponent />;

export default EditFormula;
